<template>
  <v-card>
    <v-card-title class="teal darken-4 white--text">
      Selling Form
      <v-spacer></v-spacer>
      <p>Cost: {{ (totalCost * 100).toLocaleString() }}%</p>
      <v-spacer></v-spacer>
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field
            flat
            rounded
            :suffix="'Margin ' + margType"
            type="number"
            solo
            dense
            right
            v-model.number="margin"
            name="MarginNameFild"
            label="Margin"
            id="MarginIDFild"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group class="mt-0  mr-0" dense dark row v-model="margType">
            <v-radio label="%" value="%"></v-radio>
            <v-radio label="#" value="#"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card-title>
    <!-- <p>{{ inventory }}</p> -->

    <v-data-table
      :headers="headers"
      :items-per-page="inventory.length"
      :items="inventory"
      :search="search"
    >
      <template #top>
        <v-toolbar color="grey lighten-3">
          <!-- {{ inventory }} -->
          <v-spacer></v-spacer>
          <v-text-field
            class="mt-5"
            dense
            outlined
            name="name"
            label="label"
            v-model="search"
            id="id"
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #body="{items}">
        <!-- {{ items }} -->
        <tbody>
          <newInventory
            :margin="margin"
            :margType="margType"
            :expense="totalCost"
            :rate="rate"
            v-for="(item, index) in items"
            :key="item._id + index"
            :ItemRow="item"
          ></newInventory>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { tokenMixin } from "@/Mixins/tokenMixins.js";
export default {
  mixins: [tokenMixin],
  components: {
    newInventory: () => import("@/components/HQ/TheWay/itemRow/_sellRow"),
  },
  props: {
    inventory: { type: Array },
    rate: { type: Number, default: 1 },
    costs: { type: Array, required: true },
  },
  data() {
    return {
      margType: "%",
      margin: 0,
      search: "",
      headers: [
        {
          text: "ITEM NAME",
          align: "left",
          value: "ItemName",
          class: "teal darken-3 white--text",
        },
        {
          text: "UNIT PRICE",
          value: "unitPrice",
          class: "teal darken-3 white--text",
        },
        {
          text: "UNIT COST",
          value: "unitCost",
          class: "teal darken-3 white--text",
        },
        {
          text: "TOTAL COST",
          value: "TotalCost",
          class: "teal darken-3 white--text",
        },
        {
          text: "SELLING PRICE",
          value: "SellingPrice",
          class: "teal darken-3 white--text",
        },
      ],
    };
  },

  computed: {
    TotalExpense() {
      return this.costs.reduce((total, { Account, Amount, AmountType }) => {
        if (Account != "Supplier") {
          if (AmountType != this.UserInfo.CashBase) total += Amount * this.rate;
          else total += Amount;
          return total;
        }
        return total;
      }, 0);
    },

    SuppCost() {
      // return this.inventory;
      let total = 0;
      // for (const key in this.inventory) {
      total += this.inventory.reduce(
        (Tcash, { qty, cash, unitPrice, Discount }) => {
          // Tcash = qty*unitPrice*
          if (cash != this.UserInfo.CashBase)
            Tcash += (qty * unitPrice - Discount) * this.rate;
          else Tcash += qty * unitPrice - Discount;
          return Tcash;
        },
        0
      );

      return total;
    },

    totalCost() {
      return parseFloat(this.TotalExpense / this.SuppCost);
    },
  },
};
</script>
